/* eslint-disable camelcase */

import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _includes from 'lodash/includes';
import _filter from 'lodash/filter';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import _find from 'lodash/find';
import PropTypes from 'prop-types';
// Core components
import Select from 'components/core/Select';
import TextField from 'components/core/TextField';
// Models
import mEquipment from 'models/equipment';
import mDevice from 'models/device';
// Custom
import { deviceSlaveTriggerDataShape, equipmentDataShape } from 'constants/PropTypesShapes';
import AppIcon from 'components/icons/AppIcon';

class ConfigureDeviceSlaveTrigger extends React.Component {
  constructor(props) {
    super(props);

    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleEquipmentChange = this.handleEquipmentChange.bind(this);
    this.handleTriggerFallbackChange = this.handleTriggerFallbackChange.bind(this);

    const { trigger: { equipment, fallback_trigger_id } } = this.props;

    this.state = {
      id: equipment ? equipment.id : null,
      name: equipment ? equipment.name : '',
      idTriggerFallback: fallback_trigger_id,
    };
  }

  // Handlers
  handleNameChange(value) {
    this.setState({
      name: value,
    }, this.doHandleEquipmentChange);
  }

  handleEquipmentChange(id) {
    if (!id) {
      this.setState({
        name: '',
      });
    }
    this.setState({
      id,
    }, this.doHandleEquipmentChange);
  }

  handleTriggerFallbackChange(value) {
    this.setState({
      idTriggerFallback: value,
    }, this.doHandleEquipmentChange);
  }

  // Private
  doHandleEquipmentChange() {
    const { trigger, equipments, onTriggerEquipmentChange } = this.props;
    const { id, name, idTriggerFallback } = this.state;
    let equipment;
    if (id) {
      equipment = _find(equipments, ['id', id]);
      equipment = { ...equipment, name };
    }
    onTriggerEquipmentChange(trigger, equipment, idTriggerFallback);
  }

  render() {
    const { id, name, idTriggerFallback } = this.state;
    const { trigger, equipments, triggersForFallback } = this.props;
    const filteredEquipments = mEquipment.sortElements(_filter(equipments, (eq) => (_includes(trigger.protocols, eq.protocol))));

    return (
      <div className="box box-default m-0">
        <div className="box-header box-dark">
          <LocalizedMessage
            id="info.deviceSlaveTriggerEquipment"
            values={{ triggerType: trigger.type }}
          />
        </div>
        <div className="px-3 pb-3">
          <Select
            label={<LocalizedMessage id="field.equipment" />}
            value={id}
            items={_map(filteredEquipments, (equipment) => ({
              key: _toString(equipment.id),
              value: equipment.id,
              label: `${equipment.brand} ${equipment.model} (${equipment.protocol})`,
              icon: (
                <AppIcon defaultColor id={mEquipment.type(equipment).icon} />
              ),
            }))}
            onChange={this.handleEquipmentChange}
            withNullItem
          />
          <TextField
            label={<LocalizedMessage id="field.name" />}
            disabled={!id}
            value={name}
            required={!!id}
            onChange={this.handleNameChange}
          />
          {mDevice.triggerCanHaveFallbackTrigger(trigger) && (
            <Select
              label={<LocalizedMessage id="field.fallback" />}
              value={idTriggerFallback}
              items={_map(triggersForFallback, (tr) => ({
                key: _toString(tr.id),
                value: tr.id,
                label: `${tr.equipment.name}`,
                icon: (
                  <AppIcon
                    defaultColor
                    id={mEquipment.type(tr.equipment).icon}
                  />
                ),
              }))}
              onChange={this.handleTriggerFallbackChange}
              withNullItem
            />
          )}
        </div>
      </div>
    );
  }
}

ConfigureDeviceSlaveTrigger.propTypes = {
  trigger: deviceSlaveTriggerDataShape.isRequired,
  triggersForFallback: PropTypes.arrayOf(deviceSlaveTriggerDataShape),
  equipments: PropTypes.arrayOf(equipmentDataShape),
  onTriggerEquipmentChange: PropTypes.func.isRequired,
};

ConfigureDeviceSlaveTrigger.defaultProps = {
  equipments: null,
  triggersForFallback: null,
};

const mapStateToProps = (state) => ({
  equipments: state.equipment.list.elements.data,
});

module.exports = connect(
  mapStateToProps,
  null,
)(ConfigureDeviceSlaveTrigger);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/configuration/ConfigureDeviceSlaveTrigger.js